import { NotifyHelper } from './../../../helpers/toast';
import { eTheoDoiRCDefine } from "../../action-types/theo-doi-rc/ITheoDoiRCActionTypes";
import { generateActionForKey, generateActions } from "../generateActions";

export const theoDoiRCActions = {
    ...generateActions(eTheoDoiRCDefine, "THEO_DOI_RC"),
    ...generateActionForKey(eTheoDoiRCDefine, "THEO_DOI_RC", "LOAD_ERROR", (m) => {
        NotifyHelper.Error(m)
    })
}